import { QuickfireEndRound } from "quickfire/commands/quickfire-end-round-command";
import ExitFreespins from "slotworks/state-machine/standard/states/exit-freespins";

export default class QuickfireExitFreespins extends ExitFreespins {

    public complete() {
        QuickfireEndRound();

        super.complete();
    }
}
